module.exports = __webpack_public_path__ + "img/doctor-infonews.3187fb11.svg";